import React, { useState, useEffect } from "react";
import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "react-bootstrap";
import Confirm from "../Confirm";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import FilesCreate from "../file/FilesCreate";
import RelatedListFiles from "../file/RelatedListFiles";
// import RealetedLeadTest from "./RealetedLeadTest";
// import RelatedListProjects from "../Lead/RelatedListProjects";
// import UserTracking from "./UserTracking";
// import TaskEdit from "./TaskEdit";
import Path from "../common/Path";
import moment from "moment";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
// import * as constants from '../../constants/CONSTANT';
import Permissionhelper from "../common/Permissionhelper";
import * as constants from "../../constants/CONSTANT";
import PubSub from "pubsub-js";
import Chat from "../common/Chat";
import jwt_decode from "jwt-decode";
import Helmet from "react-helmet";
import Main from "../layout/Main";
import { Shimmer } from "react-shimmer";
import Image from "react-bootstrap/Image";
import RelatedSiteVisitHistory from "../siteVisit/RelatedSiteVisitHistory";
import RelatedListTask from "../task/RelatedListTask";
// import TaskEdit from "../task/TaskEdit";
import CurrencyFormatter from "currency-formatter-react";
import { disableCursor } from "@fullcalendar/core/internal";
import { ROUTES } from "../../constants/webRouting";
import {
  formatDate,
  formatDateForCreatedDate,
  getUserDetails,
  formatDateForView,
} from "../../utils/helper";
import SiteVisitModal from "../siteVisit/SiteVisitModal";
import TaskEdit from "../task/TaskEdit";
import { RelatedListOffer } from "../offer";
import PERMISSIONS from "../../constants/permissions";
const LeadView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  //const course = location.state;
  const [spinner, setSpinner] = useState(true);
  const [lead, setLead] = useState(location?.state ? location?.state : {});
  ////console.log('lead', lead)
  const [data, setData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [showArchive, setArchiveShow] = useState(false);
  const [imageData, setImageData] = useState();
  const [modalShowFile, setModalShowFile] = useState(false);
  const [modalShowTask, setModalShowTask] = useState(false);
  const [modalShowEmail, setModalShowEmail] = useState(false);
  const [modalShowSiteVisit, setModalShowSiteVisit] = useState(false);

  const [refreshFileList, setRefreshFileList] = useState(false);
  const [refreshTaskList, setRefreshTaskList] = useState();
  const [refreshSiteVisitList, setRefreshSiteVisitList] = useState(false);
  const [refreshOfferList, setRefreshOfferList] = useState(false);
  // const [refreshLocationList, setRefreshLocationList] = useState();
  //Imran khan 13-01-2026 add isSiteVisitExists state
  const [isSiteVisitExists, setIsSiteVisitExists] = useState(false);
  const leadId = lead?.id;
  const [relatedListFiles, setRelatedListFiles] = useState(true);
  const [relatedListTaskList, setRelatedListTask] = useState(false);
  const [relatedSiteVisit, setRelatedSiteVisit] = useState(false);
  const [relatedListOrderBooking, setRelatedListOrderBooking] = useState(false);
  const [relatedListOffers, setRelatedListOffers] = useState(false);

  const [userName, setUserName] = useState("");

  const [convertShow, setConvertShow] = useState(true);

  const [showDetails, setShowDetails] = useState(true);
  const [showNotesMessages, setShowNotesMessages] = useState(false);

  const [editDisable, setDisableEdit] = useState(true);
  const [payments, setPayments] = useState({});
  // const [updateCounter, setUpdateCounter] = useState(0);

  const [leadStatusArray, setleadStatusArray] = useState(
    constants.LEAD_STATUS_VALUES,
  );
  const [userInfo, setUserInfo] = useState({});
  const [proejectTotal, setTotalAmountProject] = useState({});

  useEffect(() => {
    let userInfoJWT = getUserDetails();
    setUserInfo(userInfoJWT);
    fetchLead();
    // console.log("Lead View", lead);
    if (userInfoJWT.id === lead.owner_id) {
      // console.log("Hello Permi");
      setDisableEdit(false);
    }
    //init();
  }, []);

  const fetchLead = () => {
    if (
      !lead.id &&
      location.hasOwnProperty("pathname") &&
      location.pathname.split("/").length >= 3
    ) {
      lead.id = location.pathname.split("/")[2];
    }

    async function initStudent() {
      // console.log("lead ki id", location.state.id);
      let result = await fuziElevatorsApi.fetchLeadById(lead.id);
      let productImageResult = false; //await fuziElevatorsApi.fetchPrimaryImages(
      // lead.contactid
      // );
      if (productImageResult.id) {
        let productImageData = await fuziElevatorsApi.downloadFiles(
          productImageResult.id,
          "ContactImages",
        );
        console.log("Product image data:", productImageData);

        // Convert Blob to base64 string
        let reader = new FileReader();
        reader.readAsDataURL(productImageData);
        reader.onloadend = () => {
          let base64data = reader.result;
          console.log("Base64 Product Image:", base64data);
          setImageData(base64data);
        };
      }

      if (
        result?.convertedcontactid &&
        result?.contactname &&
        result.contactname.trim().length > 0
      ) {
        ////console.log('convert call');
        setConvertShow(false);
      }
      if (result) {
        ////console.log("=======", result);

        setLead(result);
        setData(result);
        ////console.log("name : ", lead.firstname);
      } else {
        setLead({});
      }
    }
    initStudent();
  };

  const deleteLead = async () => {
    const result = await fuziElevatorsApi.deleteLead(lead.id);

    if (result?.success) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Deleted",
        message: "Record Deleted successfully",
      });
      navigate(ROUTES.LEAD.LIST);
    } else {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Record update Error",
        message: result?.errors,
      });
    }
  };

  const archiveLeads = async () => {
    lead.isarchive = true;
    const achieveLead = await fuziElevatorsApi.saveLead(lead);
    if (achieveLead) {
      lead.lead_id = lead.id;
      const result = await fuziElevatorsApi.createArchive(lead);
      if (result.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Archive ",
          message: "Record Archive successfully",
        });
      }

      navigate(`/leads`);
    }
  };

  const edit = () => {
    navigate(`/leads/${lead.id}/e`, { state: lead });
  };

  const createProjects = () => {
    navigate("/projects/e", {
      // state: { leadView: lead.id, fromTable: "leadtable" },
      state: {
        leadView: lead.id,
        contactView: lead.contactid,
        fromTable: "leadtable",
      }, //Added by shivani 7 aug
    });
  };

  const handleSelect = (key) => {
    if (key === "files") {
      setRelatedListFiles(true);
      setRelatedListTask(false);
      setRelatedSiteVisit(false);
      setRelatedListOffers(false);
      setRelatedListOrderBooking(false);
    } else if (key === "followup") {
      setRelatedListFiles(false);
      setRelatedListTask(true);
      setRelatedSiteVisit(false);
      setRelatedListOffers(false);
      setRelatedListOrderBooking(false);
    } else if (key === "location") {
      setRelatedListFiles(false);
      setRelatedListTask(false);
      setRelatedSiteVisit(true);
      setRelatedListOffers(false);
      setRelatedListOrderBooking(false);
    } else if (key === "offers") {
      setRelatedListFiles(false);
      setRelatedListTask(false);
      setRelatedSiteVisit(false);
      setRelatedListOffers(true);
      setRelatedListOrderBooking(false);
    }
    // else if (key === "project") {
    //   setRelatedListFiles(false);
    //   setRelatedListTask(false);
    //   setRelatedSiteVisit(false);
    //   setRelatedListOffers(false);
    //   setRelatedListOrderBooking(true);
    // }
  };

  const handleSelectTab = (key) => {
    if (key === "details") {
      // setRelatedListOrderBooking(true);
      setShowDetails(true);
      setShowNotesMessages(false);
    } else if (key === "notesMessages") {
      setShowDetails(false);
      setShowNotesMessages(true);
    }
  };

  const submitFiles = () => {
    setModalShowFile(false);
    setRefreshFileList(Date.now());
    setModalShowTask(false);
    fetchLead();
  };

  const submitSiteVisit = () => {
    setModalShowSiteVisit(false);
    setRefreshSiteVisitList((prev) => !prev);
  };
  const submitTasks = () => {
    setModalShowTask(false);
    setRefreshTaskList((prev) => !prev);
  };

  const formatAmount = (value) => {
    // Check if the value is a valid number
    if (isNaN(value)) {
      return "0";
    }

    // Convert to number and format with thousand separators
    const num = parseFloat(value); // Ensure it's a number
    return num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleConvert = async () => {
    let convertStatus = "";

    let status = leadStatusArray.filter((item) => item.is_converted === true);
    //console.log("status:", status);
    convertStatus = status[0].label;
    const result = await fuziElevatorsApi.convertLeadToContact(
      lead.id,
      convertStatus,
    );
    // console.log('result', result)
    if (result) {
      let contactId = result.convertedcontactid;
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Lead Convert ",
        message: "Record Convert successfully",
      });
      navigate(`/contacts/${contactId}`);
      ////console.log("result.success : ", result.success);
    }
  };

  // Find the current status' sortorder
  //  const currentStatus = leadStatusArray.find(status => status.sortorder === lead.leadstatus);
  console.log("leadStatusArray", leadStatusArray);

  // Checking Lead Status array vallue and shwoing as till length as higlighted.
  const highlightedStatusArray = leadStatusArray.map((status) => ({
    ...status,
    highlight: status.sortorder <= lead.lead_status,
  }));

  const [currentRec, setCurrentRecord] = useState({});
  const [locationRecordv1, setLocationRecordv1] = useState({});
  const [latitudev1, setLatitudev1] = useState(null);
  const [longitudev1, setLongitudev1] = useState(null);
  console.log("lead value", lead);
  const [addressv1, setAddressv1] = useState(
    `${lead.street} ${lead.state} ${lead.zipcode}`,
  ); // Default address
  const [buttonDisabledv1, setButtonDisabledv1] = useState(false);
  const [remarksv1, setRemarksv1] = useState("");

  useEffect(() => {
    const loadGoogleMapsScript = () => {
      if (!window.google) {
        const googleMapScript = document.createElement("script");
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDtztwOW6bufAlbBWfO1k5FdZTkpUP_gmI&callback=initMap`;
        googleMapScript.async = true;
        googleMapScript.defer = true;
        googleMapScript && window.document.body.appendChild(googleMapScript);
      } else {
        window.initMap();
      }
    };

    window.initMap = () => {
      myMapFunction();
    };

    loadGoogleMapsScript();
  }, [latitudev1, longitudev1, addressv1]);

  //Imran khan 13-01-2026 useEffect to check site visit exists or not
  useEffect(() => {
    if (!leadId) return;

    async function checkSiteVisit() {
      const result = await fuziElevatorsApi.fetchsitievisiteForEnquiry(leadId);
      setIsSiteVisitExists(result && result?.length > 0);
    }

    checkSiteVisit();
  }, [leadId]);
  //End Here Imran khan 13-01-2026 useEffect to check site visit exists or not

  const myMapFunction = async () => {
    if (!latitudev1 || !longitudev1) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: addressv1 }, (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;
          setLatitudev1(location.lat());
          setLongitudev1(location.lng());

          const mapProp = {
            center: location,
            zoom: 14,
          };

          const map = new window.google.maps.Map(
            document.getElementById("googleMapaddress"),
            mapProp,
          );

          const marker = new window.google.maps.Marker({
            map,
            position: location,
            title: results[0].formatted_address,
          });

          const infowindow = new window.google.maps.InfoWindow({
            content: results[0].formatted_address,
          });

          marker.addListener("click", () => {
            infowindow.open(map, marker);
          });

          setAddressv1(results[0].formatted_address);
        } else {
          console.error(
            "Geocode was not successful for the following reason: " + status,
          );
        }
      });
    } else {
      const location = new window.google.maps.LatLng(latitudev1, longitudev1);
      const mapProp = {
        center: location,
        zoom: 14,
      };

      const map = new window.google.maps.Map(
        document.getElementById("googleMapaddress"),
        mapProp,
      );

      const marker = new window.google.maps.Marker({
        map,
        position: location,
        title: addressv1,
      });

      const infowindow = new window.google.maps.InfoWindow({
        content: addressv1,
      });

      marker.addListener("click", () => {
        infowindow.open(map, marker);
      });
    }
  };

  return (
    <Container className="pb-5">
      {lead && (
        <>
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              deleteLead={deleteLead}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="lead"
            />
          )}

          {showArchive && (
            <Confirm
              show={showArchive}
              onHide={() => setArchiveShow(false)}
              archiveLeads={archiveLeads}
              title="Confirm Archive?"
              message="You are going to Archive the record. Are you sure?"
              table="archive"
            />
          )}

          <Row className="view-form   mx-auto">
            <Col md={12} className="">
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.LEAD.LIST)}>
                  Leads
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>

            <Col lg={12} className="">
              <Container className="pb-3 sticky-card-header-view">
                <Row className="view-form-header-lead bg-custom align-items-center rounded  ">
                  <Col lg={8}>
                    Lead
                    <h5>{lead.lead_name || ""}</h5>
                  </Col>
                  <Col lg={4} className="d-flex justify-content-end gap-3">
                    {/* Add this New Site Visit button by shahir hussain 24-12-2025 */}
                    {lead.lead_status === "Site Visit Pending" && 
                      <Button
                        size="sm"
                        className="btn-custom btn-yellow float-right"
                        onClick={() => setModalShowSiteVisit(true)}
                      >
                        New Site Visit
                      </Button>
                    }
                    {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_LEAD].some(
                      (permission) => {
                        return userInfo?.permissions
                          ?.map((p) => p.name)
                          .includes(permission);
                      },
                    ) && (
                      <Button
                        size="sm"
                        className="btn-edit"
                        onClick={() => edit(true)}
                      >
                        <i className="fa-regular fa-pen-to-square"></i>
                      </Button>
                    )}
                    {[PERMISSIONS.DELETE_ALL, PERMISSIONS?.DELETE_LEAD].some(
                      (permission) => {
                        return userInfo?.permissions
                          ?.map((p) => p.name)
                          .includes(permission);
                      },
                    ) && (
                      <Button
                        size="sm"
                        className="btn-delete"
                        onClick={() => setModalShow(true)}
                      >
                        <i className="fa fa-trash-o"></i>
                      </Button>
                    )}
                  </Col>
                </Row>
              </Container>
              <Card>
                <CardHeader className="sticky-tabs-header py-3">
                  <Col lg={12} className="" style={{ color: "#fff" }}>
                    <Tabs
                      defaultActiveKey="details"
                      id="uncontrolled-tab-example"
                      onSelect={(key) => handleSelectTab(key)}
                      style={{ marginBottom: "12px" }}
                    >
                      <Tab eventKey="details" title="Details"></Tab>
                      <Tab
                        eventKey="notesMessages"
                        title="Notes & Messages"
                      ></Tab>
                    </Tabs>
                  </Col>
                </CardHeader>

                <CardBody className="card-body-scroll">
                  <Container>
                    {showDetails && (
                      <Row className="  ">
                        {/* <Col lg={12}>
                          <div className="scrollable-container">
                            <Path
                              values={highlightedStatusArray}
                              selectedValue={lead.lead_status}
                            />
                          </div>
                        </Col> */}
                        {/* Imran Khan Added Lead Status with Colors AMC Ticket 1069*/}
                        <Col lg={12} className="mb-4 mt-2">
                          <div className="scrollable-container">
                            <div className="bar">
                              {constants.LEAD_STATUS_VALUES.sort((a, b) => a.sortorder - b.sortorder).map((statusObj, index) => {
                                const currentStatusLabel = lead?.lead_status;
                                const currentStatusObj = constants.LEAD_STATUS_VALUES.find(s => s.label === currentStatusLabel);
                                const currentSortOrder = currentStatusObj ? currentStatusObj.sortorder : 0;
                                
                                const isThisStatusCurrent = currentStatusLabel === statusObj.label;
                                const isThisStatusLostType = statusObj.is_lost;

                                let stepClass = "bar-step";
                                let inlineStyle = { backgroundColor: "#bdb8b8", color: "#333", border: "1px solid #ccc" };

                                // 1. AGAR STATUS LOST HAI (RED)
                                if (isThisStatusCurrent && isThisStatusLostType) {
                                  inlineStyle = { backgroundColor: "#dc3545", color: "white", border: "1px solid #dc3545" };
                                }
                                // 2. AGAR STATUS CURRENT ACTIVE HAI (GREEN)
                                else if (isThisStatusCurrent) {
                                  stepClass = "bar-step completed"; 
                                  inlineStyle = { backgroundColor: "#28a745", color: "white", border: "1px solid #28a745" };
                                }
                                // 3. PICHLE SARE STATUS (DARK GREY/BLACK) - Yahan se sortorder === 1 wali galti hata di hai
                                else if (!isThisStatusLostType && statusObj.sortorder < currentSortOrder) {
                                  stepClass = "bar-step completed";
                                  inlineStyle = { backgroundColor: "#343a40", color: "white", border: "1px solid #343a40" };
                                }
                                
                                return (
                                  <div key={index} className={stepClass} style={inlineStyle}>
                                    {statusObj.label}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </Col>
                        {/* Added by Imran Khan 27 April 2026 Identity Tabs Legend */}
                        <Col lg={12} className="mb-4 d-flex justify-content-center gap-4 flex-wrap" style={{ borderBottom: "1px solid #eee", paddingBottom: "15px" }}>
                          <div className="d-flex align-items-center gap-2">
                            <div style={{ width: '12px', height: '12px', backgroundColor: '#28a745', borderRadius: '2px' }}></div>
                            <small className="fw-bold text-secondary">Current Status (Active)</small>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <div style={{ width: '12px', height: '12px', backgroundColor: '#dc3545', borderRadius: '2px' }}></div>
                            <small className="fw-bold text-secondary">Lost / Cancelled</small>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <div style={{ width: '12px', height: '12px', backgroundColor: '#343a40', borderRadius: '2px' }}></div>
                            <small className="fw-bold text-secondary">Completed Steps</small>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <div style={{ width: '12px', height: '12px', backgroundColor: '#bdb8b8', borderRadius: '2px', border: '1px solid #ccc' }}></div>
                            <small className="fw-bold text-secondary">Upcoming Steps</small>
                          </div>
                        </Col>
                        <>
                          <Col lg={6}>
                            <label>Enquiry No</label>
                            <span>{lead.enquiry_no}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Lead Name</label>
                            <span>{lead.lead_name || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Lead Type</label>
                            <span>{lead.leadtype}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Lead Status</label>
                            <span>{lead.lead_status}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Email</label>
                            <span>{lead.email}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Phone</label>
                            <span>{lead.phone}</span>
                          </Col>

                          <Col lg={6}>
                            <label>WhatsApp Number</label>
                            <span>{lead.whatsapp_no}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Telephone Number</label>
                            <span>{lead.teliphone}</span>
                          </Col>
                          {/* formatDateForView added by shahir hussain 27-08-2025 */}
                          <Col lg={6}>
                            <label>Date of Birth</label>
                            <span>
                              {formatDateForView(lead?.date_of_birth || "")}
                            </span>
                          </Col>

                          <Col lg={6}>
                            <label>Anniversary Date</label>
                            <span>
                              {formatDateForView(lead?.anniversary_date || "")}
                            </span>
                          </Col>

                          <Col lg={6}>
                            <label>Lead Source</label>
                            <span>{lead.leadsource}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Assigned Users</label>
                            <span>
                              <div className="d-flex flex-wrap gap-1">
                                {lead?.owner_ids?.map((item) => (
                                  <Badge
                                    bg="warning"
                                    // className="mx-2"
                                    // style={{ display: "inline", color: "#000" }}
                                  >
                                    <Link
                                      to={`${ROUTES.USER.LIST}/${item.value}`}
                                      className="text-decoration-none text-dark fw-bold"
                                    >
                                      {item.label}
                                    </Link>
                                  </Badge>
                                ))}
                              </div>
                            </span>
                          </Col>
                          <Col lg={6}>
                            <label>Created Date</label>
                            <span>
                              {formatDateForView(lead?.createddate || "")}
                            </span>
                          </Col>
                        </>

                        <>
                          <Col md={12} className="section-header">
                            Service Information
                          </Col>

                          <Col lg={6}>
                            <label>Product</label>
                            <span>{lead.product_name}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Quantity</label>
                            <span>{lead.qty}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Make</label>
                            <span>
                              {lead?.accounts
                                ?.map((item) => item.label)
                                ?.join(",") || ""}
                            </span>
                          </Col>

                          <Col lg={6}>
                            <label>Lead Enquiry Status</label>
                            <span>{lead.lead_source_status}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Referred By</label>
                            <span>{lead.contact_name}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Lead Remark</label>
                            <span>{lead.remark}</span>
                          </Col>

                          {imageData && (
                            <Image
                              style={{
                                height: "70px",
                                width: "80px",
                              }}
                              src={imageData}
                              fluid
                              alt="No Image Found"
                            />
                          )}
                        </>

                        <>
                          <Col md={12} className="section-header">
                            Customer Information
                          </Col>

                          <Col lg={6}>
                            <label>Customer Type</label>
                            <span>{lead.customer_type}</span>
                          </Col>
                          {lead?.customer_type === "Corporate" && (
                            <>
                              <Col lg={6}>
                                <label>Company Name</label>
                                <span>{lead.company_name}</span>
                              </Col>
                            </>
                          )}

                          <Col lg={6}>
                            <label>Sector</label>
                            <span>{lead.sector}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Is GST Applicable</label>
                            <span>{lead?.is_gst || "-"}</span>
                          </Col>

                          {lead?.is_gst === "Yes" && (
                            <Col lg={6}>
                              <label>GST No</label>
                              <span>{lead?.gst_no}</span>
                            </Col>
                          )}

                          <Col lg={6}>
                            <label>Competitor Name</label>
                            <span>{lead.competitor_name}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Customer Primary Name</label>
                            <span>{lead.customer_primary_name}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Customer Primary Phone</label>
                            <span>{lead.customer_primary_phone}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Second Person Name</label>
                            <span>{lead.customer_secondry_name}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Second Person Phone</label>
                            <span>{lead.customer_secondary_phone}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Second Person Designation</label>
                            <span>{lead.customer_secondary_designation}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Segment Type</label>
                            <span>
                              {typeof lead?.segment === "string" && lead.segment
                                ? lead.segment.replaceAll(",", ", ")
                                : "-"}
                            </span>
                          </Col>
                        </>
                        <>
                          <Col lg={12} className="section-header">
                            ADDRESS INFORMATION
                          </Col>

                          <Col lg={6}>
                            <label>Location Link</label>
                            <span>{lead.location_link}</span>
                            <a
                              href={
                                lead.location_link
                                  ? lead.location_link
                                  : disableCursor
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View Map
                            </a>
                          </Col>

                          <Col lg={6}>
                            <label>Address</label>
                            <span>{lead.address}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Area</label>
                            <span>{lead.area}</span>
                          </Col>

                          <Col lg={6}>
                            <label>City</label>
                            <span>{lead.city}</span>
                          </Col>

                          <Col lg={6}>
                            <label>State</label>
                            <span>{lead.state}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Office Address</label>
                            <span>{lead.office_address}</span>
                          </Col>
                          {/*Add this field by shahir hussain 24-12-2025  */}
                          <Col lg={6}>
                            <label>Office Area</label>
                            <span>{lead.office_area}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Office City</label>
                            <span>{lead.office_city}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Pincode</label>
                            <span>{lead.pincode}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Country</label>
                            <span>{lead.country}</span>
                          </Col>

                          <Col lg={12}>
                            <div
                              id="googleMapaddress"
                              className="my-2"
                              style={{
                                width: "100%",
                                height: "300px",
                                border: "1px solid black",
                              }}
                            ></div>
                          </Col>
                        </>

                        <>
                          <Col md={12} className="section-header">
                            Enquiry Information
                          </Col>

                          <Col lg={6}>
                            <label>Offer</label>
                            <span>{lead.offer_name}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Time Slot</label>
                            <span>{lead.time_slot}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Customer Site Visit Date</label>
                            <span>
                              {formatDateForView(
                                lead?.customer_site_visit_date || "",
                              )}
                            </span>
                          </Col>
                          <Col lg={12}>
                            <label>Enquiry Remark</label>
                            <span>{lead.enquiry_remark}</span>
                          </Col>
                        </>
                        {/*Imran Khan Update Lead View page for Enquiry Lost Lead Information*/}
                        {lead.lead_status === "Enquiry Lost" && (
                          <>
                            <Col lg={12} className="section-header">
                              ENQUIRY LOST LEAD INFORMATION
                            </Col>
                            <Col lg={6}>
                              <label>Lost Date</label>
                              <span>
                                {formatDateForCreatedDate(
                                  lead?.is_lost_date || "",
                                )}
                              </span>
                            </Col>
                            <Col lg={6}>
                              <label>Lead Lost Remark</label>
                              <span>{lead.lead_lost_remark}</span>
                            </Col>
                            <Col lg={6}>
                              <label>Lost By (Company)</label>
                              <span>{lead.lost_by_reason}</span>
                            </Col>
                          </>
                        )}
                        {/*End Imran Khan Update Lead View page for Enquiry Lost Lead Information*/}
                      </Row>
                    )}

                    {showNotesMessages && (
                      <Card className="mt-2">
                        <Row className="mt-4">
                          <Col lg={12}>
                            <Chat parentid={lead.id} />
                          </Col>
                        </Row>
                      </Card>
                    )}
                  </Container>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Card bg="light" text="light" className="mb-2 mt-4 shadow">
            <Card.Header className="d-flex justify-content-between">
              <Tabs
                defaultActiveKey="files"
                id="uncontrolled-tab-example"
                onSelect={(key) => handleSelect(key)}
              >
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && <Tab eventKey="files" title="Files"></Tab>}
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && <Tab eventKey="followup" title="Follow Up"></Tab>}
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_SITE_VISIT].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <Tab
                    eventKey="location"
                    title="Site Visit Location History"
                  ></Tab>
                )}
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_OFFER].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && <Tab eventKey="offers" title="Offers"></Tab>}
              </Tabs>

              {/* Buttons */}
              {relatedListFiles &&
                [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_FILE].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowFile(true)}
                  >
                    New File
                  </Button>
                )}

              {relatedListTaskList &&
                [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_TASK].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowTask(true)}
                  >
                    New Follow Up
                  </Button>
                )}

              {/* {(relatedSiteVisit && [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_SITE_VISIT].some(permission => {
                return userInfo?.permissions?.map(p => p.name).includes(permission);
              })) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowSiteVisit(true)}
                  >
                    New Site Visit
                  </Button>)
              } */}
              {/*Imran Khan 12-01-2026 updated New Site Visit button on Lead View page as per client needs*/}
              {/* {console.log("Check Lead Status", isSiteVisitExists)} */}
              {relatedSiteVisit &&
                !isSiteVisitExists &&
                [PERMISSIONS.MODIFY_ALL, PERMISSIONS.MODIFY_SITE_VISIT].some(
                  (permission) =>
                    userInfo?.permissions?.some((p) => p.name === permission),
                ) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowSiteVisit(true)}
                  >
                    New Site Visit
                  </Button>
                )}
              {/*End Here Imran Khan 12-01-2026 updated New Site Visit button on Lead View page as per client needs*/}

              {/* Modals */}
              {modalShowFile && (
                <FilesCreate
                  show={modalShowFile}
                  onHide={() => setModalShowFile(false)}
                  parent={lead}
                  table="medicaltest"
                  submitFiles={submitFiles}
                />
              )}

              {modalShowTask && (
                <TaskEdit
                  show={modalShowTask}
                  onHide={() => setModalShowTask(false)}
                  parentid={lead?.id}
                  table="lead"
                  submitTasks={submitTasks}
                />
              )}

              {modalShowSiteVisit && (
                <SiteVisitModal
                  show={modalShowSiteVisit}
                  onHide={() => setModalShowSiteVisit(false)}
                  parent={lead}
                  submitSiteVisit={submitSiteVisit}
                />
              )}
            </Card.Header>
            <Card.Body>
              {/* File related List */}
              {relatedListFiles &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <RelatedListFiles
                    refreshFileList={refreshFileList}
                    // onFileUpdate={updateCounter}
                    parent={lead}
                    submitFiles={submitFiles} //Added by shivani
                  />
                )}

              {/* Task related List */}
              {relatedListTaskList &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <RelatedListTask
                    refreshTaskList={refreshTaskList}
                    parent={lead}
                    submitFiles={submitTasks}
                    table="Lead"
                  />
                )}

              {/* Site visit related List */}
              {relatedSiteVisit &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_SITE_VISIT].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <RelatedSiteVisitHistory
                    refreshSiteVisitList={refreshSiteVisitList}
                    parent={lead}
                  />
                )}

              {/* Offer related List */}
              {relatedListOffers &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_OFFER].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <RelatedListOffer
                    refreshOfferList={refreshOfferList}
                    lead={lead}
                  />
                )}
            </Card.Body>
          </Card>
        </>
      )}
    </Container>
  );
};
export default LeadView;
